/**
 * Models an API healthcheck datasource status
 */

import Brace from "backbone.brace";

const Healthcheck = Brace.Model.extend({
  namedAttributes: {
    name: String,
    enabled: Boolean,
    exception: String,
    status: String,
  },

  defaults: {
    name: null,
    enabled: null,
    exception: null,
    status: null,
  },
});

export { Healthcheck as default };
